export const STATE_BREADCRUMB = 'STATE_BREADCRUMB'

export const MUT_SET_BREADCRUMB = 'MUT_SET_BREADCRUMB'

export const NAMESPACE = 'breadcrumb/'
